import packageJson from '../../package.json';

export function getReleaseVersion(): string {
  return packageJson.version || '0.0.0';
}

export function getProjectName(): string {
  return packageJson.name || 'spark-frontend';
}
